module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgBXZC/agJBEMZn91YCIQHzBhJCCPlHHuHsLI6w6S7JhZxv4BuoT+AjaKfYeIKNlb6BomKhFlda2sp5jjPqyeoUM9/ub2Z2+QRcRM51MymZ6rGWJrC1TiupWgCYAdyCMuHt9U2VygcghhbG2dPk5+9fhYpOQNBohHvo/HhFRCyQXFkCvxjwvWIgAEp8wE2cD5r1YbJNJoBQrdOsB+YfJAKUD1L4juvZJrRm41H/8e1d0Aabkn54eu3Op+PlHnI6Ntxxg7Rk7v7lub2YTFbCXON8ezWa/qcnwmgbZc8cUleqQN1DdogtPJvk0L6fjtfRgPUOsgdRDfZAdk8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_old/arrow_left_active.png
// module id = 1658
// module chunks = 3 5 6